import { configureStore } from '@reduxjs/toolkit'
import commonSlice from './features/common/common.slice'
import depositSlice from './features/deposit/deposit.slice'
import loansSlice from './features/loans/loans.slice'

export const store = configureStore({
    reducer: {
        loans: loansSlice,
        common: commonSlice,
        deposit: depositSlice
    }
})

export type RootState = ReturnType<typeof store.getState>
export type AppDispatch = typeof store.dispatch